import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledSecondaryNavigationPlaceholder = styled.div`
  height: ${toRem(56)};
`;

export const StyledSecondaryNavigationContainer = styled.div<{
  isSticky: boolean;
  top: number;
  shouldAnimateTop: boolean;
  shouldAnimateBottom: boolean;
}>`
  position: ${({ isSticky }) => (isSticky ? 'fixed' : 'relative')};
  top: ${({ isSticky, top }) => (isSticky ? `${top}px` : 'auto')};
  left: ${({ isSticky }) => (isSticky ? '0' : 'auto')};
  width: ${({ isSticky }) => (isSticky ? '100%' : 'auto')};
  z-index: ${({ isSticky }) => (isSticky ? 29 : 'auto')};
  ${({ isSticky, shouldAnimateTop, shouldAnimateBottom }) =>
    isSticky && (shouldAnimateTop || shouldAnimateBottom) ? 'transition: top 0.4s ease;' : ''}

  @media ${baseVariables.mediaQuery.lg} {
    top: ${({ isSticky, top }) => (isSticky ? `${Math.max(top - 1, 0)}px` : 'auto')};
  }
`;
